import React from 'react';
import { useStyles } from './styles';
import { Box, Button, Typography } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useTheme } from '@material-ui/core/styles';
import InfoIcon from '@material-ui/icons/Info';

export const LmaValidate = (props) => {
  const classes = useStyles();
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
 
  return (
    <Dialog fullScreen={fullScreen} PaperProps={{ classes: { root: classes.dialogStyle } }} onClose={props.handleGotIt} open={props.open}>

      <Box className={classes.root}>
          
        <Box className={classes.cardBody}>
         <Box display='flex' alignItems="center" justifyContent="center">
          <InfoIcon className={classes.paidInFullIcon} />
          <Typography className={classes.statusTitle}>Important: Missing Required Documents</Typography>
         </Box> 
        </Box>
        
        <Box className={classes.cardBodyContainer}>
          <Box className={classes.imageContainer}>
            <Typography className={classes.paragraph}>We’ve noticed that some required documents for your loss mitigation application are missing. Please upload the following documents before proceeding:</Typography>
              <ul className={classes.instruction}>
              {props?.docValidations?.map((cat) => (
                cat.subCategory.map((subCat) => (<li className={classes.docTitle}>{subCat.supportDocName}</li>))
              ))}
              </ul>  
              <Typography className={classes.mandatoryTitle}><b>Note:</b> Ensure all above mandatory documents are uploaded, then try again.</Typography> 
          </Box> 
        </Box>

        <Box className={classes.cardFooter}>
          <Button
            variant='contained'
            color='primary'
            className={classes.btn}
            onClick={props.handleGotIt}
            >Got it</Button>
        </Box>
       
      </Box> 
    </Dialog>
  )
}
